<template lang="pug">
div
  b-form(v-if="user.role==='admin'" @submit.stop.prevent="onSubmit")
    .box-form
      .material-icons.icon-input.pr-1 perm_identity
      b-form-group(
        label="Destinatario"
        invalid-feedback="Este campo es requerido"
      )
        b-form-input#customer-input.input(
          v-model="form.finalCustomer"
          maxlength="150"
          :state="$v.$dirty ? !$v.form.finalCustomer.$invalid : null"
        )

    .box-form
      .material-icons.icon-input.pr-1 phone
      b-form-group(
        label="Teléfono"
      )
        b-form-input#customer-phone-input.input(
          v-model="form.contactPhone"
          @update="cleanPhoneOnUpdate(form)"
        )
    .box-form
      .material-icons.icon-input.pr-1 email
      b-form-group(
        label="Email"
      )
        b-form-input#customer-email-input.input(
          v-model="form.contactEmail"
        )

    .box-form(v-if="user.role!=='store' && !driverId")
      .material-icons.icon-input.pr-1 perm_identity
      b-form-group(
        label="Conductor"
      )
        v-select(
          v-model="form.driverId"
          :options="driverOptions"
          label="text"
          placeholder="Selecciona un Conductor"
          :reduce="driver => driver.value"
          @option:selected="onChangeDriver"
        )
          span(slot="no-options") Lo siento, no se pudo encontrar el conductor

    .box-form
      .material-icons.icon-input.pr-1 comment
      b-form-group(
        label="Comentario Interno"
      )
        b-form-textarea#internal-comment.input(
          v-model="form.internalComment"
          maxlength="1000"
        )

    .box-form
      .material-icons.icon-input.pr-1 local_shipping
      b-form-group(
        label="Partner (Courier)"
      )
        b-form-select(
          v-model="form.partnerCode"
        )
          b-form-select-option(:value="null") Selecciona un Partner
          b-form-select-option(
            v-for="partner in partnerOptions"
            :key="partner.value"
            :value="partner.value"
          ) {{ partner.text }}
    b-card.mb-2(
      v-if="delivery.lastPartnerSyncAt !== null && delivery.partnerCode !== null"
      variant="info"
      no-body
      style="margin-left: 37px; border-radius: 5px; background-color: #F5F5F5; padding: 10px;"
    )
      div(style="font-weight: bold; font-size: 14px;") Seguimiento Partner
      div(style="font-size: 12px;") Ultima Sincronización: {{$moment(delivery.lastPartnerSyncAt).format('DD-MM-YYYY HH:mm')}}
      div(style="font-size: 12px;") Codigo de seguimiento: {{delivery.partnerDeliveryId}}
      div(style="font-size: 12px;") Estado: {{partnerUtils.partnerDeliveryStatusLabels[delivery.partnerCode][delivery.partnerDeliveryStatus]}}
    b-card.mb-2(
      v-if="delivery.partnerDeliverySyncError"
      variant="danger"
      no-body
      style="margin-left: 37px; border-radius: 5px; background-color: #F5F5F5; padding: 10px; max-height: 100px; overflow-y: auto;"
    )
      div(style="font-weight: bold; font-size: 14px;") Error de Sincronización
      div(style="font-size: 12px;") {{delivery.partnerDeliverySyncError}}
    .box-form()
      .material-icons.icon-input.pr-1 store
      b-form-group(
        label="Tienda"
      )
        v-select(
          v-model="storeSelected"
          :options="storeOptions"
          label="text"
          placeholder="Selecciona una Tienda"
          @option:selected="onChangeStore"
        )
          span(slot="no-options") Lo siento, no se pudo encontrar la tienda
    .box-form(v-if="!date && user.role!=='store'")
      .material-icons.icon-input.pr-1 calendar_today
      b-form-group(
        label="Fecha"
        invalid-feedback="Este campo es requerido"
      )
        b-form-input#date-input.input(
          v-model="form.date"
          type="date"
          readonly
        )
    .box-form
      .material-icons.icon-input.pr-1 place
      b-form-group(
        label="Comuna"
      )
        b-form-input#commune-input.input(
          v-model="form.commune"
          maxlength="256"
        )

    .box-form
      .material-icons.icon-input.pr-1 place
      b-form-group(
        label="Dirección"
      )
        b-form-input#street-input.input(
          v-model="form.address"
          maxlength="256"
        )

    .text-right
    div(v-if="editMode")
      .box-form
        .material-icons.icon-input.pr-1 pin
        b-form-group(
          label="Código"
        )
          b-form-input#code-input.input(
            v-model="form.drivInCode"
            readonly
          )

      .box-form
        .material-icons.icon-input.pr-1 playlist_add_check
        b-form-group(
          label="Observaciones"
        )
          b-form-textarea#observations-input.input(
            v-model="form.observations"
            maxlength="256"
            no-resize
          )

      .box-form
        .material-icons.icon-input.pr-1 sell
        b-form-group(
          label="Tags"
        )
          b-form-select#tags.input(
              v-model="form.tags"
              :options="tagsOptions"
              :disabled="loading"
            )

      .box-form
        .material-icons.icon-input face
        b-form-group.pl-2(
          label="Persona que Recibe"
          invalid-feedback="Este campo es requerido"
        )
          b-form-input#receiver-name.input(
            v-model="form.receiverName"
            type="text"
            autocomplete="off"
            :disabled="loading"
            placeholder="Ingresa el nombre"
          )

      .box-form
        .material-icons.icon-input pin
        b-form-group.pl-2(
          label="Rut"
          invalid-feedback="El rut es requerido"
        )
          b-form-input#receiver-rut.input(
            v-model="form.receiverRut"
            type="text"
            autocomplete="off"
            :disabled="loading"
            placeholder="Ingresa el Rut"
          )

      .box-form
        .material-icons.icon-input.pr-1 place
        b-form-group(
          label="Estado"
          :disabled="!!form.partnerCode"
          :description="!!form.partnerCode ? 'El estado no se puede modificar si el envio tiene un partner' : ''"
        )
          b-form-select#state-input.input(v-model="form.status")
            b-form-select-option(:value="'approved'") Entregado
            b-form-select-option(:value="'in-transit'") En Tránsito
            b-form-select-option(:value="'partial'") Pendiente
            b-form-select-option(:value="'rescheduled'") Reprogramado
            b-form-select-option(:value="'rejected'") Rechazado
            b-form-select-option(:value="'cancelled'") Cancelado

      .box-form
        .material-icons.icon-input.pr-1 comment
        b-form-group(
          label-for="comentary-input"
        )
          .input-title Comentario de entrega
          b-form-textarea#commentary-input.input(
            v-model="form.comment"
            maxlength="256"
            no-resize
          )

      .box-form
        .material-icons.icon-input image
        b-form-group.pl-2(
          label-for="delivery-images"
          invalid-feedback="Debe ingresar al menos 1 foto"
        )
          .input-title Imágenes (4 max.):
          .d-flex
            b-form-file#input-file.input.mr-2(
              v-model="photosToLoad"
              placeholder="Toca aquí para abrir la galería"
              browse-text="Buscar"
              accept="image/*"
              multiple
              :disabled="loading"
            )
            b-button.d-flex.py-0(
              style="align-items: center;"
              @click="openCamera"
              variant="primary"
              size="sm"
              :disabled="loading"
            )
              .material-icons camera_alt
          b-form-file#open-camera.d-none(
            v-model="photosToLoad"
            accept="image/*"
             multiple
             :capture="true"
          )
      div.scroll-container(v-if="delivery.images.length > 0" style="display: flex; flex-wrap: wrap; margin-top: 10px; margin-bottom: 10px; gap: 10px;")
        div(v-for="(image, index) in imagesToShow" style="position: relative; width: 120px; height: 120px;")
          b-img(
          style="position: relative; width: 120px; height: 120px; margin-right: 10px; margin-bottom: 10px; border-radius: 10px; position: relative; border: 1px solid #E5E5E5; overflow: hidden; object-fit: contain;"
          :key="index"
          :src="image"
          class="img-details")
          b-button(
            style="position: absolute; top: -10px; right: -10px; height: 20px; width: 20px; font-size: 5px; padding: 0; display: flex; justify-content: center; align-items: center;"
            @click="form.imagesToRemove.push(image)"
            variant="danger"
            size="sm"
            class="delete-photo"
            pill
          )
            .material-icons close
      div.test1(style="display: flex; flex-wrap: wrap; margin-top: 10px; margin-bottom: 10px; gap: 10px;")
        div.test2(v-for="(image, index) in imageUrls")
          div(style="position: relative; width: 120px; height: 120px;")
            b-img(
              style="position: relative; width: 120px; height: 120px; margin-right: 10px; margin-bottom: 10px; border-radius: 10px; position: relative; border: 1px solid #E5E5E5; overflow: hidden; object-fit: contain;"
              v-if="image"
              :key="index"
              :src="image"
              class="photo"
              fluid
            )
            b-button(
              style="position: absolute; top: -10px; right: -10px; height: 20px; width: 20px; font-size: 5px; padding: 0; display: flex; justify-content: center; align-items: center;"
              @click="form.images.splice(index, 1)"
              variant="danger"
              size="sm"
              class="delete-photo"
              pill
            )
              .material-icons close

    .text-right
      b-button(type="submit" :disabled="loading") Guardar
</template>

<script>
import Compressor from 'compressorjs'
import { mapActions, mapGetters } from 'vuex'
import MakeToastMixin from '../mixins/MakeToastMixin'
import { required } from 'vuelidate/lib/validators'
import vSelect from 'vue-select'
import { io } from 'socket.io-client'
import settings from '../../../settings.js'
import { cleanPhone } from '../../utils/cleanData'
import { getInvalidFeedback } from '../../utils/customValidations'
import partnerUtils from '../../utils/partnerUtils'
import { isDriverRole } from '../../constants/userRoles'

export default {
  mixins: [MakeToastMixin],
  props: {
    delivery: {
      type: Object,
      default: null
    },
    editMode: Boolean,
    driverId: Number,
    noIncudeHide: Boolean,
    date: [Date, String]
  },
  components: {
    vSelect
  },
  data() {
    return {
      partnerUtils,
      loading: false,
      websocketUrl: settings.baseApi.split('api')[0],
      isException: false,
      noExceptionAllowed: false,
      stores: [],
      driversToEmit: [],
      storesToEmit: [],
      storeSelected: null,
      photosToLoad: null,
      form: {
        finalCustomer: this.editMode ? this.delivery.finalCustomer : '',
        contactPhone: this.editMode ? this.delivery.contactPhone : '',
        driverId: this.driverId ? this.driverId : (this.editMode ? this.delivery.driverId : null),
        internalComment: this.editMode ? this.delivery.internalComment : '',
        contactEmail: this.editMode ? this.delivery.contactEmail : '',
        storeId: this.editMode ? this.delivery.storeId : null,
        partnerCode: this.editMode ? this.delivery.partnerCode : null,
        customerName: this.editMode ? this.delivery.customerName : '',
        date: this.date ? this.date : (this.editMode ? this.$moment(this.delivery.date.substring(0, 10)).format('YYYY-MM-DD') : ''),
        status: this.editMode ? this.delivery.status : null,
        comment: this.editMode ? this.delivery.comment : '',
        observations: this.editMode ? this.delivery.observations : '',
        address: this.editMode ? this.delivery.address : '',
        commune: this.editMode ? this.delivery.commune : '',
        drivInCode: this.delivery.drivInCode,
        tags: this.delivery.tags,
        receiverName: this.editMode ? this.delivery.receiverName : '',
        receiverRut: this.editMode ? this.delivery.receiverRut : '',
        images: [],
        imagesToRemove: []
      },
      tagsOptions: [
        { text: 'N/A', value: null },
        { text: 'Flex', value: 'flex' },
        { text: 'Cambio', value: 'exchange' },
        { text: 'Devolución', value: 'return' }
      ]
    }
  },
  validations() {
    const form = {
      finalCustomer: { required }
    }
    return { form }
  },
  methods: {
    getInvalidFeedback(field) {
      return getInvalidFeedback(field)
    },
    cleanPhoneOnUpdate(item) {
      this.$nextTick(() => {
        if (item.contactPhone !== cleanPhone(item.contactPhone)) {
          item.contactPhone = cleanPhone(item.contactPhone)
        }
      })
    },
    ...mapActions(['createDelivery', 'updateDelivery', 'listUser', 'listAllStoreName']),
    async onSubmit() {
      this.loading = true
      if (this.$v.$invalid) {
        this.$v.$touch()
        this.loading = false
      } else {
        if (this.editMode) {
          await this.onUpdateDelivery()
        } else {
          await this.onCreateDelivery()
        }
      }
    },
    openCamera() {
      document.getElementById('open-camera').click()
    },
    async onCreateDelivery() {
      const response = await this.createDelivery({ data: this.form })
      if (response.status === 201) {
        this.makeSuccessToast('El viaje se creó correctamente')
        this.$emit('done')
        if (this.$route.meta.back) {
          this.$router.push(this.$route.meta.back)
        }
      } else if (response.status >= 400) {
        this.makeDangerToast(response.data.message || 'Error al crear el viaje')
      }
    },
    async onUpdateDelivery() {
      this.loading = true
      try {
        if (this.delivery.customerName) this.storesToEmit.push(this.delivery.customerName)
        if (this.delivery.customerName !== this.form.customerName) this.storesToEmit.push(this.form.customerName)
        if (this.delivery.driverId) this.driversToEmit.push(this.delivery.driverId)
        if (this.delivery.driverId !== this.form.driverId) this.driversToEmit.push(this.form.driverId)

        const formData = new FormData()
        for (const key in this.form) {
          if (key === 'contactPhone') {
            this.form[key] = cleanPhone(this.form[key])
          }
          if (this.form[key] === null) {
            continue
          }
          if (!['images', 'imagesToRemove'].includes(key)) { // Excluir 'images' y 'imagesToRemove'
            formData.append(key, this.form[key])
          }
          if (key === 'imagesToRemove') {
            formData.append(key, JSON.stringify(this.form[key]))
          }
        }

        // Procesar y agregar imágenes al FormData
        if (this.form.images && this.form.images.length > 0) {
          for (const img of this.form.images) {
            await new Promise((resolve, reject) =>
              new Compressor(img, {
                quality: 0.4,
                maxHeight: 720,
                maxWidth: 720,
                success(result) {
                  const extension = result.name.split('.').pop()
                  formData.append('files', result, `IMG_${new Date().getTime()}.${extension}`)
                  resolve()
                },
                error(err) {
                  console.error(err.message)
                  reject(err)
                }
              })
            )
          }
        }
        const response = await this.updateDelivery({ data: formData, id: this.delivery.id })
        if (response.status === 200) {
          this.makeSuccessToast('El viaje se editó correctamente')
          this.$emit('done', { drivers: this.driversToEmit, stores: this.storesToEmit })
        } else if (response.status >= 400) {
          this.makeDangerToast(response.data.message || 'Error al editar el viaje')
        }
      } catch (error) {
        console.error(error.message)
        this.makeDangerToast('Ocurrió un error al actualizar la entrega')
      } finally {
        this.loading = false
      }
    },
    onChangeStore(store) {
      this.form.storeId = store.value
      this.form.customerName = store.text
    },
    onChangeDriver(driver) {
      this.form.driverId = driver.value
    },
    async initWebsockets() {
      console.log('conectando a websocket')
      this.socket = io(this.websocketUrl)

      this.socket.on('delivery:updated', (data) => {
        console.log('Envío actualizado', data || '')
      })
    }
  },
  computed: {
    ...mapGetters(['users', 'user']),
    partnerOptions() {
      return partnerUtils.partnerSelectOptions
    },
    imagesToShow() {
      if (this.delivery.images.length > 0) {
        return this.delivery.images.filter(image => !this.form.imagesToRemove.includes(image))
      }
      return []
    },
    storeOptions() {
      const stores = []
      this.stores.forEach(store => {
        stores.push({ value: store.id, text: store.name })
      })
      return stores
    },
    imageUrls() {
      if (!this.form.images) return []
      const urls = []
      if (this.form.images) {
        for (const img of this.form.images) {
          urls.push(URL.createObjectURL(img))
        }
      }
      return urls
    },
    driverOptions() {
      return this.users
        .filter(user => isDriverRole(user.role))
        .map(user => ({
          value: user.id,
          text: `${user.name} ${user.lastName}`
        }))
    }
  },
  async created() {
    if (this.user.role === 'admin') {
      if (!this.driverId) {
        this.listUser()
      }
      const stores = await this.listAllStoreName()
      this.stores = stores
      if (this.delivery?.storeId) {
        const storeFounded = this.stores.filter((s) => s.id === this.delivery.storeId)
        this.storeSelected = storeFounded.length ? storeFounded[0].name : null
      }
    }
  },
  watch: {
    'form.images': {
      handler(value) {
        if (this.form.images.length >= 5) {
          this.form.images.pop()
        }
      },
      deep: true
    },
    photosToLoad(value) {
      if (value) {
        if (!this.photosToLoad) return
        for (const photo of value) {
          this.form.images.push(photo)
        }
        this.photosToLoad = null
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.img-details {
  position: relative;
  width: 120px;
  height: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  position: relative;
  border: 1px solid #E5E5E5;
  overflow: hidden;
  object-fit: contain;
}

.scroll-container {
  display: flex;
  white-space: nowrap;
  gap: 10px;
}
</style>
